import { WalletList } from "../walletprovider/components/WalletList";
import { WalletError } from "../walletprovider/components/WalletError";
import React, { useEffect, useContext } from "react";
import { AppContext } from "../AppContextProvider";
import { useTranslation } from 'react-i18next';

function LoginPage() {
  const { t } = useTranslation();
  const context = useContext(AppContext);

  useEffect(() => {
    if (context.getState()?.isConnection) {
      context.isLogin(false);
    }
    localStorage.setItem("isLottieLookingAtIt", "false");
  }, []);

  return (
    <div className="loginpage-div">
      <WalletList />
      <WalletError />
    </div>
  );
}

export default LoginPage;
